<template>
  <div :class="[`view-479`, className || ``]">
    <div class="rectangle-203-10"></div>
    <div class="text-4-2 poppins-bold-white-20px">Доступно</div>
  </div>
</template>

<script>
export default {
  name: "View482",
  props: ["className"],
};
</script>

<style>
.view-479 {
  align-self: center;
  height: 40px;
  margin-left: 16px;
  position: relative;
  width: 152px;
}

.rectangle-203-10 {
  background-color: var(--shamrock);
  border-radius: 10px;
  height: 40px;
  left: 0;
  position: absolute;
  top: calc(50% - 20px);
  width: 150px;
}

.text-4-2 {
  left: 25px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 5px;
}

.view-479.view-481 {
  margin-left: 10px;
}

.view-479.view-482 {
  align-self: center;
  height: 40px;
  margin-left: 10px;
  position: relative;
  width: 152px;
}

.view-479.view-483,
.view-479.view-485,
.view-479.view-487,
.view-479.view-489 {
  align-self: center;
  height: 40px;
  margin-left: 60px;
  position: relative;
  width: 152px;
}

.view-479.view-483 .rectangle-203-10,
.view-479.view-485 .rectangle-203-10,
.view-479.view-487 .rectangle-203-10,
.view-479.view-489 .rectangle-203-10,
.view-479.view-484 .rectangle-203-10,
.view-479.view-486 .rectangle-203-10,
.view-479.view-488 .rectangle-203-10,
.view-479.view-490 .rectangle-203-10 {
  background-color: var(--rose-of-sharon);
}

.view-479.view-484,
.view-479.view-486,
.view-479.view-488,
.view-479.view-490 {
  align-self: center;
  height: 40px;
  margin-left: 54px;
  position: relative;
  width: 152px;
}
</style>
